import { jsx as o, Fragment as l } from "react/jsx-runtime";
import { a as f } from "./useFeatureFlag-yISLemKJ.js";
const g = ({ children: e, fallback: t, ...i }) => {
  const n = f(), { flag: s, flags: u, exact: r } = i;
  return s && n[s] ? /* @__PURE__ */ o(l, { children: e }) : u && r && u.every((a) => n[a]) ? /* @__PURE__ */ o(l, { children: e }) : u && !r && u.some((a) => n[a]) ? /* @__PURE__ */ o(l, { children: e }) : t ? /* @__PURE__ */ o(l, { children: t }) : null;
}, y = (...e) => (t) => {
  const i = (n) => {
    const s = f();
    return e.some((r) => typeof r == "string" ? s[r] : r.every((a) => s[a])) ? /* @__PURE__ */ o(t, { ...n }) : null;
  };
  return i.displayName = `WithFeatureFlag(${F(t)})`, i;
};
function F(e) {
  return e.displayName || e.name || "Component";
}
export {
  g as F,
  y as w
};
//# sourceMappingURL=withFeatureFlag-TwokSfWw.js.map
